export default __webpack_public_path__ + "static/retail-snow-21d26aded4e7071946bbe91ffb96f2e8.gif";